/**
 * OpenList 文件图标组件
 */

"use client"

import {
  File,
  FileSpreadsheet,
  FileText,
  ImageIcon,
  Video,
} from "lucide-react"
import type { OpenListFileType } from "@/types/openlist"
import { getFileIconConfig } from "@/lib/utils/openlist-file-utils"

interface OpenListFileIconProps {
  fileType: OpenListFileType
  className?: string
}

export function OpenListFileIcon({ fileType, className = "h-4 w-4" }: OpenListFileIconProps) {
  const config = getFileIconConfig(fileType)
  const iconClassName = `${className} ${config.colorClass}`

  switch (config.iconType) {
    case 'FileText':
      return <FileText className={iconClassName} />
    case 'FileSpreadsheet':
      return <FileSpreadsheet className={iconClassName} />
    case 'ImageIcon':
      return <ImageIcon className={iconClassName} />
    case 'Video':
      return <Video className={iconClassName} />
    case 'File':
    default:
      return <File className={iconClassName} />
  }
}
